export default {
  'app.setting.pagestyle': 'نمط الصفحة',
  'app.setting.pagestyle.light': 'فاتح',
  'app.setting.pagestyle.dark': 'داكن',
  'app.setting.content-width': 'عرض المحتوى',
  'app.setting.content-width.fixed': 'ثابت',
  'app.setting.content-width.fluid': 'سائل',
};
